// @flow

import * as React from 'react';
import {ButtonLink} from 'sail/Button';
import {MenuItem, OverflowMenu} from 'sail/Menu';
import Group from 'sail/Group';
import {InfoTooltip} from 'sail/Tooltip';
import {useArticle, useAnalytics} from 'docs/data';

import type {XRayMode} from './XRayMode';
import './XRayToggle.scss';

type XRayToggleProps = {|
  mode: XRayMode,
  setMode: (value: XRayMode) => any,
|};

export const XRayToggle = ({mode, setMode}: XRayToggleProps) => {
  const {isLoading} = useArticle();
  const {trackAction} = useAnalytics();

  const isOpen = mode === 'xray';

  const icon = isOpen ? 'arrowDown' : 'arrowUp';

  let label;
  if (isLoading) {
    label = 'Loading';
  } else {
    label = isOpen ? 'Hide x-ray view' : 'Show x-ray view';
  }

  const handleClick = () => {
    if (!isOpen) {
      trackAction('docs_xray', {type: 'xray_opened'});
    }
    if (!isLoading) {
      setMode(isOpen ? 'normal' : 'xray');
    }
  };

  return (
    <Group
      className="XRayToggle"
      background="yellow500"
      direction="horizontal"
      alignItems="center"
      justifyContent="space-between"
      padding={{vertical: 12, horizontal: 20}}
    >
      <Group direction="horizontal" spacing={8} alignItems="center">
        <ButtonLink
          size="medium"
          color="white"
          icon={icon}
          label={label}
          pending={isLoading}
          onClick={handleClick}
        />
        {!isOpen && (
          <InfoTooltip
            iconColor="white"
            content="X-ray is an internal-only view that shows extra information about a docs page."
          />
        )}
      </Group>
      <OverflowMenu
        className="XRayToggle--menu"
        hoverable
        color="white"
        size="small"
        contextMeetingPoint="top"
        layerMeetingPoint="bottom"
      >
        <MenuItem onClick={() => setMode('disabled')}>
          Disable until refresh
        </MenuItem>
      </OverflowMenu>
    </Group>
  );
};
